var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoltage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.104,
    height: 39.007,
    viewBox: "0 0 24.104 39.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(5992.584 1393.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(-5992.584 -1393.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M138.409,206.849l-1.261,15.742,6.851,1.5-11.091,21.766,2.5-17.385-6.926-.555Z",
    transform: "translate(-123.863 -206.849)",
    fill: "#275d97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M124.441,218.821l-7.441-7.2,1.664-1.689,6.778,6.744Z",
    transform: "translate(-117 -203.762)",
    fill: "#275d97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M123.169,217.974l-5.962-5.835,1.172-2.211,6.453,6.356Z",
    transform: "translate(-100.728 -187.968)",
    fill: "#275d97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M126.886,219.723l-9.535-9.438",
    transform: "translate(-110.066 -196.918)",
    fill: "#275d97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678_-_Outline",
    "data-name": "Path 678 - Outline",
    d: "M126.492,221.411l-9.075-9.186,1-2.148,9.212,9.089Z",
    transform: "translate(-109.976 -197.203)",
    fill: "#e1e9f1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltage);
export default __webpack_public_path__ + "static/media/voltage.859587bd.svg";
export { ForwardRef as ReactComponent };